<!-- =========================================================================================
  File Name: TicketList.vue
  Description: Ticket List
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Webspiders
  Author URL: https://www.webspiders.com
========================================================================================== -->
<template>
  <div class="manage-team-type-wrap">
    <div class="manage-type-head">
      <h2><feather-icon icon="ArrowLeftIcon" class="mr-2" @click="$router.push('/event/checkin')" /> &nbsp; Manage Type <vs-icon icon="info_outline" size="small" color="#cdcdcd" class="ml-2"></vs-icon></h2>

      <div class="team-head-right">
          <vs-button @click="getTypeDetail(null)" color="#1a73e8" type="filled" class="send-team-invi-button disable-button-invitation"><feather-icon icon="PlusIcon" class="mr-2" /> Create New</vs-button>
         <!--  <input type="text" value="" placeholder="Search"/> -->
      </div>
    </div>

    <div class="mt-5 checkin-type-list">
      <vs-table max-items="10" pagination  search :data="TypeList">
        <template slot="header">
                  <h3>
                    Checkin Types
                  </h3>
                </template>
        <template slot="thead">
          <vs-th>
            &nbsp;
          </vs-th>
          <vs-th sort-key="Name">
            Name
          </vs-th>
          <!-- <vs-th>
            No. of Volunteers Assigned
          </vs-th> -->
          <vs-th sort-key="CheckInType">
            Checkin Type
          </vs-th>
          <vs-th sort-key="DisplayOrder">
            Display Order
          </vs-th>
          <vs-th colspan="2">
           Action
          </vs-th>
          
        </template>

        <template slot-scope="{data}">
          <vs-tr :data="item" :key="indextr" v-for="(item, indextr) in data">
            <vs-td >
                <div class="checkin-type-image">
                  <img :src="item.TypeIconUrl"/>
                </div>
            </vs-td>

            <vs-td >
                <h5>{{item.Name}}</h5>
            </vs-td>

            <!-- <vs-td >
                <h5>0</h5>
            </vs-td> -->
            <vs-td >
                <h5>{{item.CheckInType}}</h5>
            </vs-td>
            <vs-td >
                <h5>{{item.DisplayOrder}}</h5>
            </vs-td>

            <vs-td >
                <div v-if="item.CheckInType=='Session'" @click="generateQR(item)" class="flex justify-end items-center">
                   <img src="../../assets/images/print-qr.svg" class="mr-2"/><h5>Print QR</h5>
                </div>
            </vs-td>

             <vs-td >
                <div class="flex justify-end items-center">
                  <vs-button @click="getTypeDetail(item.TypeId)" color="#333333" type="flat" size="small" ><img src="../../assets/images/edit.svg" style="height: 25px; width:25px;"/></vs-button>                  
                  <!-- <vs-button v-if="item.CheckInType=='Session'" @click="generateQR(item)" class="ml-3" color="#333333" type="border" icon="download"></vs-button>  -->                
                </div>
            </vs-td>
          </vs-tr>          
        </template>
      </vs-table>
    </div>
    <div class="centerx">
      <vs-popup class="holamundo checkin-type-popup"  title="Add New Check-in Type" :active.sync="popupActivo">
        <div class="checkin-type-wrapper-hld" v-if="TypeDetail">
          <div class="checkin-type-details">  
            <div v-if="TypeDetail.TypeId">
                <h3>{{TypeDetail.CheckInType}}</h3>
                <vs-switch v-model="TypeDetail.IsPublished"/>
            </div>
            <div v-else>
                <label>Check-in Type</label>
                <ul class="leftx">
                    <li :class="TypeDetail.CheckInType == 'Custom' ? 'active' : ''"><vs-radio v-model="TypeDetail.CheckInType" vs-name="CheckInType" vs-value="Custom" color="#ffffff">Custom</vs-radio></li>
                    <li :class="TypeDetail.CheckInType == 'Session' ? 'active' : ''"><vs-radio :disabled="sessionTypeFound" v-model="TypeDetail.CheckInType" vs-name="CheckInType" vs-value="Session">Session</vs-radio></li>
                </ul> 
            </div> 
            <div v-if="TypeDetail.CheckInType=='Session'">
                <label>Select Sessions</label>
                <v-select
                    multiple
                  class="mt-1"
                  v-model="TypeDetail.Sessions"
                  :options="SessionList"
                  label="Name"
                />  
            </div> 
            <div class="vx-row">
              <div class="vx-col md:w-1/2 w-full">
                <label>Check-in Type Name</label>
                <input type="text" v-model="TypeDetail.Name"/>
              </div>
              <div class="vx-col md:w-1/2 w-full mt-8">
                <label>Display Order</label>
                <vs-input-number min="1" v-model="TypeDetail.DisplayOrder"/>
              </div>
              <div class="vx-col md:w-1/2 w-full mt-4">
                <label>Description</label> 
                <textarea cols="12" rows="8" v-model="TypeDetail.Description" class="description-wrap"/>
              </div>
              
              <div class="vx-col md:w-1/2 w-full">
                <p class="mt-4">Add Icon</p>
                <input type="text" v-model="TypeDetail.TypeIconUrl"/>
                <div class="checkin-type-image-hld mt-3">
                  <div class="checkin-type-image-icon">
                    <img v-if="TypeDetail.TypeIconUrl" :src="TypeDetail.TypeIconUrl">
                    <vs-icon v-else icon="wallpaper" size="35px" color="#d8dce0"></vs-icon>
                  </div>
                  <div class="checkin-type-image-details">
                    <h5>Drag &amp; drop or upload to add check-in icon</h5>
                    <p>Image should  be 1:1 ratio in PNG, JPG, SVG.</p>
                    <p>Max file size 2MB</p>
                    <input type="file" ref="update_icon_input" class="hidden" @change="iconUpload($event, 'TypeIconUrl')" accept="image/*"/>
                    <vs-button color="#4c4e50" type="filled" class="mt-4" @click="$refs.update_icon_input.click()">Upload</vs-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="qr-generate-hld">
            <div class="qr-code-hld"></div>
            <div class="qr-generate-btn">
              <img src="../../assets/images/qr.svg" class="mr-2"/>
              <h5>GENERATE QR</h5>
            </div>
          </div> -->
        </div>
        <div class="flex justify-end align-center action-pop-button" v-if="TypeDetail">
          <vs-button color="#333" type="border" class="mr-2" @click="popupActivo=false;TypeDetail=null;">Cancel</vs-button>
          <vs-button color="#1a73e8" type="filled" @click="saveTypeDetail">{{TypeDetail.TypeId ? 'Update' : 'Add'}}</vs-button>
        </div>
      </vs-popup>
    </div>
  </div>
</template>
<script>
import vSelect from "vue-select";
import ls from "@/common/localStorage"

// Store Module
import moduleCheckinteamManagement from "@/store/checkinteam-management/moduleManagement.js";
import moduleSessionManagement from "@/store/session-management/moduleSessionManagement.js";
import commonMixin from '@/mixins/common'

var cn = ls.getSessionEventCollectionName();
export default {
  mixins: [commonMixin],
  components: {
    vSelect,

  },  
  data() {
    
    return {
       popupActivo:false,
        TypeList: [],
        TypeDetail: null,
        sessionTypeFound: false,
        SessionList: [],
        Sessions: []
    };
  },
  watch: {
  },
  computed: {
  },
  methods: {
    iconUpload(input, fieldName){
      if (input.target.files && input.target.files[0]) {
        const bgImgfile = input.target.files[0];
        const metadata = { contentType: bgImgfile.type };
        const validImageTypes = ["image/jpeg", "image/png"];
        if (!validImageTypes.includes(bgImgfile.type)) {
          alert("Only gif,jpeg & png file allowed.");
          return false;
        }
        let FileSize = bgImgfile.size / 1024 / 1024;
        if (FileSize > 1) {
          alert("Uploaded file size exceeds 1 MB");
          return false;
        }
        //this.data_local[fieldName] = bgImgfile;
        const reader = new FileReader();
        reader.onload = (e) => {
          this.uploadIconFile(bgImgfile, fieldName);
        };

        reader.readAsDataURL(input.target.files[0]);
      }
    },
    uploadIconFile(file, fieldName) {
      this.$vs.loading();
      this.$store
        .dispatch("checkinteamManagement/uploadImage", {
          file: file,
          path: cn + "/checkinteam/",
        })
        .then((res) => {
          this.$vs.loading.close();
          this.TypeDetail[fieldName] = res;
        })
        .catch((err) => {
          //console.error(err)
          this.$vs.loading.close();
        });
    },
    getTypeList(){
      this.$store.dispatch("checkinteamManagement/fetchTypeList").then(res=>{
        this.TypeList = res        
        this.sessionTypeFound = res.some(type=>type.CheckInType=='Session');        
      })
    },
    getTypeDetail(id){
        this.$vs.loading();
        this.$store.dispatch("checkinteamManagement/fetchTypeDetail", id).then(res=>{
            this.$vs.loading.close();
            this.TypeDetail = res.data
            this.popupActivo = true;
        }).catch(err=>{
            this.$vs.loading.close();
        })
    },
    saveTypeDetail(){        
        if(!this.TypeDetail || !this.TypeDetail.Name){
          this.popupActivo = false;
          this.$vs.dialog({
            type: "alert",
            position: "top-center",
            color: "warning",
            title: "Status",
            text: "Check-in Type Name mandatory!",
            //accept: this.deleteRecord,
            acceptText: "OK",
          });
          return false;
        }
        this.$vs.loading();
        let TypeId = this.TypeDetail.TypeId;
        if(TypeId){
            this.$store.dispatch("checkinteamManagement/updateTypeDetail", {id:TypeId,data:this.TypeDetail}).then(res=>{
                this.$vs.loading.close();
                this.TypeDetail = null
                this.popupActivo = false;
                this.getTypeList();
            }).catch(err=>{
                this.$vs.loading.close();
                this.$vs.notify({
                  color: "warning",
                  position: "top-center",
                  text: "Something went wrong!",
                });
            })
        }else{
            this.$store.dispatch("checkinteamManagement/addTypeDetail",{data:this.TypeDetail}).then(res=>{
                this.$vs.loading.close();
                this.TypeDetail = null;
                this.popupActivo = false;
                this.getTypeList();
            }).catch(err=>{
                this.$vs.loading.close();
                this.$vs.notify({
                  color: "warning",
                  position: "top-center",
                  text: "Something went wrong!",
                });
            })
        }
    },
    getSessionList(){
        this.SessionList = [];
        this.$store.dispatch("sessionManagement/fetchSessions").then((res) => {
            for(let session of res){
                if(session.IsPublished){
                    this.SessionList.push({
                        Name: session.Name,
                        SessionId: session.SessionId,
                        StartDate: new Date(session.StartDate.seconds*1000),
                        EndDate: new Date(session.EndDate.seconds*1000)
                    });
                }
            }
        });
    },
    async generateQR(type) {
      let sessions = await this.$store.dispatch('checkinteamManagement/fetchSessionsByTypeId', `${type.TypeId}`);
      let ids = sessions.map(item=> item.SessionId);
      if (ids.length) {
        this.$vs.loading();
        this.$store
          .dispatch("sessionManagement/generateQR", ids)
          .then( (res) => {
            this.$vs.notify({
              color: res.status == 200 ? "success" : "warning",
              position: "top-center",
              text: res.message,
            });
            for(let item of res.data){
              if(item.status == 0){ 
                let filename = "QR_" + ls.getSessionEventCollectionName() + "_" + item.data.substr(item.data.lastIndexOf("/"));     
                this.downloadImageFromURL(item.data, filename);  
              }
            }
            this.$vs.loading.close();
          })
          .catch((err) => {
            console.error(err)
            this.$vs.loading.close();
            this.$vs.notify({
              color: "warning",
              position: "top-center",
              text: "Something went wrong!",
            });
          });
      } else {
        this.$vs.dialog({
          type: "alert",
          position: "top-center",
          color: "warning",
          title: "Status",
          text: "Please assign a session",
          //accept: this.deleteRecord,
          acceptText: "OK",
        });
      }
    },
  },
  mounted() {
    this.getTypeList();
    this.getSessionList();    
  },
  created(){
    if (!moduleCheckinteamManagement.isRegistered) {
      this.$store.registerModule(
        "checkinteamManagement",
        moduleCheckinteamManagement
      );
      moduleCheckinteamManagement.isRegistered = true;
    }
    if (!moduleSessionManagement.isRegistered) {
      this.$store.registerModule("sessionManagement", moduleSessionManagement);
      moduleSessionManagement.isRegistered = true;
    } 
  }
};
</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
.manage-type-head h2 {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin: 0 !important;
    line-height: 23px;
}
.manage-type-head {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.team-head-right {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  .team-head-right input[type="text"] {
    width: 166px;
    height: 41px;
    margin: 0;
    border: 1px solid #dfdfdf;
    background: transparent !important;
    padding: 0 15px;
    margin-left: 15px;
    font-weight: 400;
    font-size: 14px;
    color: #333;
  }
  .team-head-right input[type="text"]:focus{outline: none !important;}
  .send-team-invi-button .vs-button-text {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .checkin-type-image {
    height: 60px;
    width: 60px;
    background: #000;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
}
.checkin-type-image img{max-width: 100%; height: auto;}
.checkin-type-list table thead tr {
    background: #f2f3f5;
    border-bottom: 1px solid #cdcdcd;
}
.checkin-type-list table thead tr th {
    font-weight: 600;
    font-size: 15px;
    color: #545555;
}
.checkin-type-list table thead tr th:nth-child(3) .vs-table-text{justify-content: center;}
.checkin-type-list table tr td:nth-child(3), .checkin-type-list table tr td:nth-child(4), .checkin-type-list table tr td:nth-child(5){text-align: center;}
.checkin-type-list table thead tr th:last-child .vs-table-text{justify-content: center;}
.checkin-type-list table tr.tr-values.vs-table--tr {border-bottom: 1px solid #cdcdcd;}
.checkin-type-popup .vs-popup {width: 992px !important;}
.checkin-type-details input[type="text"] {width: 100%; height: 50px; border: 1px solid #cdcdcd; border-radius: 5px; font-size: 14px; font-weight: 400; color: #333; margin-top: 5px;}
.checkin-type-image-icon {width: 205px; height: 205px; flex: 205px 0 0; overflow: hidden; border: 1px solid #ebeeef; border-radius: 6px; background: #f5f7f9; display: flex; justify-content: center; align-items: center;}
.checkin-type-image-icon img{max-width: 100%; height: auto;}
.checkin-type-image-hld {display: flex; justify-content: flex-start;align-items: flex-start;}
.checkin-type-image-details {padding-left: 15px;}
.checkin-type-details {width: 100%;}
ul.leftx {display: flex; justify-content: flex-start; align-items: center; margin-bottom: 10px;}
.checkin-type-wrapper-hld {margin-bottom: 30px;}
.qr-generate-hld {width: 50%; padding-left: 30px;display: flex;justify-content: center; align-items: center;border-left: 1px solid #cdcdcd}
.qr-generate-btn {display: flex; justify-content: center; align-items: center; border: 2px solid #cdcdcd; padding: 10px 25px; border-radius: 6px; cursor: pointer;}
.action-pop-button button {width: 120px;}
.action-pop-button {padding: 25px 0 5px; border-top: 1px solid #cdcdcd;}
.checkin-type-details .vs-input-number{display: inline-flex;}
textarea.description-wrap {width: 100%; margin-top: 7px !important; border: 1px solid #cdcdcd; border-radius: 6px; resize: none; height: 264px; padding: 10px; color: #000; font-weight: 400;}
.leftx li {width: 100px; height: 35px; background: #fff; display: flex; justify-content: center; align-items: center; border: 1px solid #4c8bf6;overflow: hidden;}
.leftx li:first-child{border-radius: 5px 0 0 5px;}
.leftx li.active{background:#4c8bf6 !important;}
.leftx li:last-child{border-radius: 0px 5px 5px 0px;border-left: none;}
.leftx li.active label span.vs-radio--label {color: #fff !important;}
.leftx li label span.vs-radio--label{color: #333 !important;}
</style>